import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { TabPanel, TabView } from "primereact/tabview";
import { formatDate } from "../../config/Config";
import { Image } from "primereact/image";
import { useEffect, useRef, useState } from "react";
import PoliticalPartyRequirements from "./PoliticalPartyRequirements";
import { useContext } from "react";
import { PoliticalPartyDBContext } from "./PoliticalPartyDBContext";
import RegistredAndNonRegistered from "./RegistredAndNonRegistered";
import NationalExecutiveCommittee from "./NationalExecutiveCommittee";
import PoliticalDocuments from "./PoliticalDocuments";
import PoliticalPartyAgent from "./PoliticalPartyAgent";
import PoliticalPartyInfo from "./PoliticalPartyInfo";
import PoliticalRegisteredElectors from "./PoliticalRegisteredElectors";
import { Button } from "primereact/button";
import PoliticalPartyUsers from "./PoliticalPartyUsers";
import PoliticalProportional from "./PoliticalProportional";
import PoliticalRepresentativesComponent from "./PoliticalRepresentativesComponent";
import { contestationPeriodsService } from "../../services/ContestationPeriodsService";
import { Dropdown } from "primereact/dropdown";
import ScreenLoader from "../../componets/ScreenLoader";
import PoliticalMembershipYearDropdown from "./PoliticalMembershipYearDropdown";
import PoliticalPartyExecutiveTerm from "./PoliticalPartyExecutiveTerm";
import PoliticalPartyExecutiveTermDropdown from "./PoliticalPartyExecutiveTermDropdown";

export default function PoliticalPartyDetail({ }) {
	const [activeTabIndex, setActiveTabIndex] = useState(0);
	var { refresh_politicalParties, setRefresh_PoliticalParties, selectedParty, setSelectedParty, contestationPeriodID, partyExecutiveTermID, setContestationPeriodID } = useContext(PoliticalPartyDBContext);

  useEffect(() => {
    const handleClick = (e) => {
      // Find the closest element with the relevant class
      const nextBtn = document.querySelector('.p-tabview-nav-next.p-tabview-nav-btn.p-link');
      const clickedNext = e.target.closest('.p-tabview-nav-next.p-tabview-nav-btn.p-link');
      const clickedPrev = e.target.closest('.p-tabview-nav-prev.p-tabview-nav-btn.p-link');

      if (clickedNext && nextBtn) {
        nextBtn.style.display = 'none'; // hide next button
      }

      if (clickedPrev && nextBtn) {
        nextBtn.style.display = ''; // reset to default display (make visible)
      }
    };

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

	return (
		<>
			<Dialog
				// maximized
				draggable={false}
				header={<span>{`Political Party Details - ${selectedParty?.name} `}</span>}
				style={{ width: "90%", height: "90%" }}
				modal
				visible={true}
				onShow={() => {
					// execMembersHandler();
					// membersHandler();
					// execMemberRoleAvail();
					// documentsHandler();
				}}
				onHide={(e) => {
					setRefresh_PoliticalParties(!refresh_politicalParties)
					setSelectedParty(null);
				}}
				footer={
					<>
						{activeTabIndex == 0 && <Button id="update_political_party_button" label="Submit" />}
						<Button className="p-button-danger" onClick={() => setSelectedParty(null)} label="Close" />
					</>
				}
			>


				<TabView scrollable tabIndex={activeTabIndex} onBeforeTabChange={(e) => setActiveTabIndex(e.index)}>
					<TabPanel header="Party Details">
						<PoliticalPartyInfo />
					</TabPanel>

					<TabPanel header="Executive Terms">
						<PoliticalPartyExecutiveTerm />
					</TabPanel>
					<TabPanel header={"Executive Committee"}  >
						<PoliticalPartyExecutiveTermDropdown />
						{!["", null, undefined].includes(partyExecutiveTermID) && (<><NationalExecutiveCommittee key={partyExecutiveTermID} /></>)}
					</TabPanel>
					<TabPanel header={"Members"}>
						<PoliticalMembershipYearDropdown />
						{!["", null, undefined].includes(contestationPeriodID) && (<><RegistredAndNonRegistered /></>)}
					</TabPanel>

					<TabPanel header={"Documents"}>
						<PoliticalDocuments />
					</TabPanel>
					<TabPanel header={"Portal Users"}>
						<PoliticalPartyUsers />
					</TabPanel>
					<TabPanel header={"Party List"}>
						<PoliticalRepresentativesComponent />
					</TabPanel>
					<TabPanel header={"Agents"}>
						<PoliticalPartyAgent />
					</TabPanel>

				</TabView>


			</Dialog>
		</>
	);
}


